import { render } from "./DishList.vue?vue&type=template&id=4e6bf868&scoped=true&ts=true"
import script from "./DishList.vue?vue&type=script&lang=ts"
export * from "./DishList.vue?vue&type=script&lang=ts"

import "./DishList.vue?vue&type=style&index=0&id=4e6bf868&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.27_typescript@5.9.3__webpack@5.106.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e6bf868"]])

export default __exports__